var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.75 5.25L5.25 18.75","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.75 18.75L5.25 5.25","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = X;

X.default = X;
